// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostItem_wrapper__2x7QL","image":"PostItem_image__2RuZ5","content":"PostItem_content__2pxL1","date":"PostItem_date__1RvyM","title":"PostItem_title__1IBKo"};